import { httpCreate } from './http';

const http = httpCreate('/srv/activityMediaLibDot');

export const activityMediaLibDot = {
	/** 新增/编辑打点信息
	 * @param { Number } activityId 直播间ID
	 * @param { Number } mediaLibId 视频ID
	 * @param { Number } data.id    主键id 有就传
	 * @param { String } remarks 备注
	 * @param { Number } dotTime 单位秒
	 * @param { String } photoUrl 打点截图
	 * @returns
	 */
	updateDot(activityId, mediaLibId, data) {
		return http.post(`/${activityId}/${mediaLibId}`, data);
	},
	// 获取打点列表
	getDotList(activityId, mediaLibId, params) {
		return http.get(`/${activityId}/${mediaLibId}`, { params });
	},
	// 删除单个打点信息
	deleteDot(activityId, dotId) {
		return http.delete(`/${activityId}/${dotId}`);
	},
	// 清空打点信息
	clearDot(activityId, mediaLibId) {
		return http.delete(`/all/${activityId}/${mediaLibId}`);
	},
	// 打点状态变更
	changeDotStatus(activityId, mediaLibId, status) {
		return http.put(`/${activityId}/${mediaLibId}/${status}`);
	},
};
